module.exports = __webpack_public_path__ + "img/413.98bcb8c9.jpg";